<template>
<div class="page-saver-container">
  <transition name="fade">
    <div :class="classes" v-if="isModified">
      <div class="wrapper">
        <div class="page-saver--message notranslate">
          <p v-if="changeCount>0">
            <template>
              {{$tc('ui.pages.lead-change-count', changeCount, { num: `${changeCount}` } )}}
            </template>
          </p>
        </div>
        <div class="page-saver--actions actions">
          <button class="btn btn-flat btn-cancel" data-action="item.cancel" @click="cancel">{{$t('ui.global.cancel')}}</button>
          <button class="btn btn-secondary" data-action="item.update" @click="save">{{$t('ui.global.save')}}</button>
        </div>
      </div>
    </div>
  </transition>
</div>
</template>
<script>
export default {
  props: {
    isModified: {
      default: true
    },
    changeCount: {
      default: 0
    },
    sticky: {
      default: false
    }
  },
  computed: {
    classes() {
      let classes = ['page-saver']
      if (this.sticky) {
        classes.push('sticky')
      }
      return classes
    }
  },
  methods: {
    save(){
      this.$emit('save')
    },
    cancel(){
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
.page-saver-container {
  margin-top: 10px;
}
.sticky {
  position: fixed;
  height: 70px;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  padding: 10px 0;
  box-shadow: 0 -20px 66px 0 rgba(34,48,73,0.2);
  justify-content: flex-end;
  z-index: 9999999999;
  display: flex;
  align-items: center;
}
.fade-enter, .fade-leave-to{
  .page-saver{
    bottom: -50px;
    opacity: 0.5;
  }
}
.fader-enter-active, .fade-leave-active{
  .page-saver{
    transition: all 350ms linear;
  }
}
.page-saver {
  .wrapper{
    align-items: center;
    display: flex;
    padding: 0px 40px 0px 0px;
    margin: 0px;
    @include respond-to("medium"){
      .actions{
        text-align: center;
        .btn{
          padding: 0 15px;
        }
      }
    }
  }
  .page-saver--message{
    flex-grow: 6;
    align-self: center;
    text-align: right;
    padding: 0 15px;
    p {
    font-weight: $font-medium;
    font-size: 14px;
    color: $ink-light;
    margin: 0px;
    margin-top: 1px;
   }
  }
  .actions{
    text-align: right;
  }

  .btn-cancel {
    background: transparent;
    color: $red;
    font-size: 14px;
    font-weight: $font-medium;
    border: 0;
    transition: all .15s ease-out;
  }
  .btn-cancel:hover {
    color: $red-dark;
  }
  .btn-cancel:active  {
    color: $red-dark;
  }
}
</style>



// WEBPACK FOOTER //
// PageSaver.vue?28c8d0fa